'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data) {
    let $couponSignupMessage = $('.coupon-signup-message');
    let $couponForm = $('form.coupon-signup');

    $.spinner().stop();

    if (data.success) {
        $couponSignupMessage.addClass('d-flex').find('.response-wrapper').append(data.msg);
    } else {
        $('.response-wrapper', $couponSignupMessage).append('<div class="coupon-signup-alert text-center alert-danger" role="alert">' + data.msg + '</div>');
        $couponSignupMessage.addClass('d-flex');
    }

    $('html, body').animate({
        scrollTop: $('.coupon-signup-form').offset().top - 200
    }, 500);

    $couponForm.addClass('d-none');
}

/**
 * Hide thank you message
 */
function closeMessage() {
    let $couponSignupMessage = $('.coupon-signup-message');
    let $couponForm = $('form.coupon-signup');
    var button = $('.signup-coupon');

    $couponSignupMessage.removeClass('d-flex').find('.response-wrapper').empty();
    $couponForm.removeClass('d-none');
    button.removeAttr('disabled');
}

/**
 * Submits the coupon signup form to the Coupon-Submit route
 * @param {JQuery} form - the coupon form as a jQuery object
 * @param {string} url - the Coupon-Submit route's url
 * @param {JQuery} button - the button as a jQuery object
 */
function coupon(form, url) {
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            if (data.success) {
                displayMessage(data);
                $('.coupon-signup').trigger('reset');
            } else if (data.error) {
                if (data.type && data.type === 'mismatch') {
                    form.find('#coupon-form-emailconfirm').addClass('is-invalid').siblings('.invalid-feedback').text(data.msg);
                    $.spinner().stop();
                    $('.signup-coupon').removeAttr('disabled');
                } else {
                    displayMessage(data.msg);
                }
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                displayMessage(err);
            }
        }
    });
}

module.exports = {
    couponSignup: function () {
        $('form.coupon-signup').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.signup-coupon');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            coupon(form, url);
        });

        $('.coupon-signup-message .close').on('click', function () {
            closeMessage();
        });
    }
};
